import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column row-md bg-white items-center justify-center" }
const _hoisted_2 = {
  class: "q-gutter-md q-py-sm q-px-lg text-center",
  id: "footer"
}
const _hoisted_3 = { class: "text-blue-grey-10 q-mr-sm" }

import { useQuasar } from 'quasar'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const year = new Date().getFullYear()

const q = useQuasar()

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_footer = _resolveComponent("q-footer")!

  return (_openBlock(), _createBlock(_component_q_footer, { elevated: "" }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["q-ml-md-auto q-py-md-sm", { 'full-width bg-blue-grey-6 text-center': _unref(q).screen.lt.md }])
        }, [
          _createVNode(_component_q_btn, {
            color: "primary",
            flat: "",
            dense: "",
            size: "sm",
            href: "https://catispa.com",
            target: "_blank",
            alt: "Cati spa",
            class: "q-mx-sm"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_3, "© " + _toDisplayString(_unref(year)), 1),
              _cache[0] || (_cache[0] = _createTextVNode(" CATI spa ", -1))
            ]),
            _: 1
          })
        ], 2)
      ])
    ]),
    _: 3
  }))
}
}

})